import * as React from "react";
import { useHistory } from "react-router";

import {
  TypeFinancementApi,
  TypeFinancementSearch,
  FcbTypeFinancementGridDto,
  EBooleanSearchTypes
} from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton, SearchTablePage, ViewButton } from "../../../../../components";
import { useAbortableApiServiceFactory, useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import styled from "styled-components";

interface ITypeFinancementListPageProps {}

const Container = styled.div`
  display: flex;
`;

export const TypeFinancementListPage: React.FunctionComponent<ITypeFinancementListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(TypeFinancementApi);

  const columns = React.useMemo(
    () => [
      {
        computed: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: FcbTypeFinancementGridDto) => (
          <Container>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.typeFinancement}/${row.idfinancementType}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.typeFinancement}/${row.idfinancementType}/detail/edit`)}
            />
          </Container>
        )
      },
      {
        header: () => t(ETLCodes.Code),
        fieldName: "code"
      },
      {
        header: () => t(ETLCodes.Libelle),
        fieldName: "libelle"
      }
    ],
    [history, t]
  );

  const onAddItem = React.useCallback(() => {
    history.push(`${ERoutes.typeFinancement}/0/detail/edit`);
  }, [history]);

  const getCriteriasFn = React.useCallback(() => api.typeFinancementGetSearchCriterias({ includeListsValues: true }), [
    api
  ]);

  const apiFactory = useAbortableApiServiceFactory(TypeFinancementApi);
  const lastAbortController = React.useRef<AbortController>();
  const searchFn = React.useCallback(
    (sObj?: TypeFinancementSearch) => {
      const { api: abortableApi, abortController } = apiFactory();
      lastAbortController.current = abortController;
      return abortableApi.typeFinancementBaseSearch({ TypeFinancementSearch: sObj });
    },
    [apiFactory]
  );

  const onAbort = React.useCallback(() => lastAbortController.current?.abort(), []);

  return (
    <SearchTablePage
      sortKeys={{ code: "ASC" }}
      getCriteriasFunction={getCriteriasFn}
      searchFunction={searchFn}
      onAbort={onAbort}
      columns={columns}
      breadCrumbs={[{ text: t(ETLCodes.TypesFinancement), route: ERoutes.typeFinancement }]}
      addFunc={onAddItem}
      defaultCriterias={[
        {
          criteria: "Actif",
          searchMode: EBooleanSearchTypes.Equals,
          value: true
        }
      ]}
    ></SearchTablePage>
  );
};
